export const VAALIKONE_TOKEN_KEY = 'alma_vaalikone_token'
export const baseUrl = process.env.API_URL
export const imagePrefix = process.env.IMG_URL
